import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

function WorkExpirienceHeader({
  fields,
}) {
  return (
    <Row className="fw-bold">
      <Col sm={11}>
        <Row>
          <Col sm={10} className="text-center">
            {fields.position.label}
          </Col>
          <Col sm={2} className="text-center">
            {fields.date_from.label}
          </Col>
          <Col sm={10} className="text-center">
            {fields.company.label}
          </Col>
          <Col sm={2} className="text-center">
            {fields.date_to.label}
          </Col>
          <Col sm={12} className="text-center">
            {fields.leaving_reason.label}
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

WorkExpirienceHeader.propTypes = {
  fields: PropTypes.shape({
    type: PropTypes.shape({
      label: PropTypes.string,
    }),
    contact: PropTypes.shape({
      label: PropTypes.string,
    }),
  }).isRequired,
};

export default WorkExpirienceHeader;
